import React, { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { UserHover } from "Components";
import { getFirstLetterOfName } from "Utils";
import { paths } from "Constant/paths";

export const UserSidebar = ({ userGid, projectId, stageId, userList }) => {
  const [showUserPopover, setShowuserPopover] = useState("");

  const {
    admin: {
      applicationStatus: { root, overview },
    },
  } = paths;

  // Toggle
  const handleUserPopoverMouseEnter = (popoverId) => {
    setShowuserPopover(popoverId);
  };

  const handleUserPopoverMouseLeave = () => {
    setShowuserPopover("");
  };
  return (
    <div className="applicant-list-bar bg-white">
      <ul>
        {userList &&
          userList.length > 0 &&
          userList.map((applicant, index) => (
            <li
              className={applicant.gid === userGid ? "active" : ""}
              key={`${applicant.gid}${index}`}
            >
              <div
                onMouseEnter={() =>
                  handleUserPopoverMouseEnter(`${applicant.gid}-${index}`)
                }
                onMouseLeave={handleUserPopoverMouseLeave}
              >
                <OverlayTrigger
                  placement="right"
                  show={showUserPopover === `${applicant.gid}-${index}`}
                  overlay={
                    <Popover className="max-w-unset">
                      <UserHover user={applicant} />
                    </Popover>
                  }
                >
                  <div className="d-flex align-items-center">
                    <a
                      className="applicant-avatar"
                      href={`${root}/${applicant.gid}${overview}?projectId=${projectId}&stageId=${stageId}`}
                    >
                      {applicant.photoURL ? (
                        <img
                          src={applicant.photoURL}
                          alt={`${applicant.firstName}${applicant.lastName}`}
                        />
                      ) : (
                        getFirstLetterOfName(applicant)
                      )}
                    </a>
                  </div>
                </OverlayTrigger>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
};
